export default "__VITE_ASSET__BPOtGNQG__"